module.exports = __webpack_public_path__ + "static/media/DXC XD Research Projects.db5a9656.csv";